module.exports = __webpack_public_path__ + "img/89.2a034c94.jpg";